
"use client";
import btn_share from "@/app/assets/orders/btn_share@2x.png"
import small_diamond from "@/app/assets/mine/small_diamond@2x.png";
import Image from "next/image";

export type OpenTypeOrderComponentType = {
  item: {
    marketQuestion: string;
    marketImage: string;
    status: string;
    currentValue: string;
    totalPositions: [{
      outcomeName: string;
      position: number;
    }];
    profitLoss: number;
    profitLossPercent: string;
    orders: [{
      amount: number;
      amountStr: string;
      createTime: string;
      orderId: string;
      shares: number;
      sharesStr: string;
      title: string;
    }],
    outcomeResult?: string;
    settlementTime?: string;
  },
  openOrderDetails: (orderId: string) => void;
};

export const OpenTypeOrderComponent: React.FC<OpenTypeOrderComponentType> = ({ item, openOrderDetails }) => {
  const {
    marketQuestion,
    marketImage,
    status,
    currentValue,
    totalPositions,
    profitLoss,
    profitLossPercent,
    orders,
  } = item;

  return (
    <div className="mb-[1rem] pt-[2rem] pb-[1.6rem] bg-[#48426550] rounded-[2rem]">
      <div className="flex px-[2rem] items-start justify-between">
        <Image src={marketImage} alt="bit" width={24} height={24} />
        <div className="text-white ml-[.5rem] text-[1.5rem] font-bold">{marketQuestion || ''}</div>
        <div className={`ml-[1rem] text-[1rem] font-bold ${status === 'OPEN' ? 'text-[#52FF91]' : 'text-[#FF4D88]'}`}>
          {status}
        </div>
      </div>
      <div className="px-[2rem] flex items-center justify-between mt-[1rem]">
        <div>
          <div className="text-[1.2rem] text-bravve-200 opacity-50">Current Value</div>
          <div className="flex flex-row items-center gap-3">
            <div className="font-bold text-[1.5rem] text-bravve-200">{currentValue}</div>
            <Image src={small_diamond} alt="small_diamond" width={16} height={16} />
          </div>
        </div>
        <div>
          <div className="text-[1.2rem] text-bravve-200 opacity-50">Total Position</div>
          <div className="flex flex-row items-center gap-8">
            {
              totalPositions.map((item, index) => (
                <div key={index} className="flex items-center gap-2 font-bold text-[1.5rem] text-bravve-200">{item?.position} <span className="text-[1rem] font-medium text-bravve-200">{item?.outcomeName}</span></div>
              ))
            }
          </div>
        </div>
        <div>
          <div className="text-[1.2rem] text-bravve-200 opacity-50">Profit&Loss</div>
          <div className="flex flex-row items-center gap-8">
            <div className="font-bold text-[1.5rem] text-bravve-200">{profitLoss}</div>
            <div className={`font-bold text-[1.5rem] ${status === 'OPEN' ? 'text-[#52FF91]' : 'text-[#FF4D88]'}`}>{profitLossPercent}</div>
          </div>
        </div>
        <div className="flex flex-col items-center gap-1">
          <Image src={btn_share} alt="btn_share" width={30} height={30} />
        </div>
      </div>
      {
        status === 'OPEN' ? <div className="h-[.2rem] bg-white opacity-20 mt-[1rem]"></div> :
          <div className="flex items-center justify-between bg-[#ffffff20] px-[2rem] py-[.5rem] mt-[1rem]">
            <div className="text-[1.3rem] text-bravve-200 font-bold">{item?.outcomeResult}</div>
            <div className="text-[1.3rem] text-bravve-200 opacity-50">{item?.settlementTime}</div>
          </div>
      }
      {
        orders && orders.length > 0 && orders.map((item, index) => {
          const { amount, amountStr, createTime, orderId, shares, sharesStr, title } = item;
          return <div className="px-[2rem] my-[1.5rem] cursor-pointer" key={index}>
            <div onClick={() => {
              openOrderDetails && openOrderDetails(orderId);
            }}>
              <div className="flex justify-between">
                <div className="text-[1.5rem] text-bravve-200 font-bold">{title}</div>
                <div className="text-[1.1rem] text-bravve-200 opacity-50">{createTime}</div>
              </div>
              <div className="flex items-center gap-50">
                <div className="flex flex-row items-center gap-3">
                  <div className="font-bold text-[1.5rem] text-bravve-200">{amountStr}</div>
                  <Image src={small_diamond} alt="small_diamond" width={16} height={16} />
                </div>
                <div className="text-[1.3rem] text-bravve-200">{sharesStr} shares</div>
              </div>
              {
                index == orders.length - 1 ? null : <div className="w-full h-[.1rem] opacity-10 bg-bravve-200 mt-[1.5rem]"></div>
              }
            </div>
          </div>
        })
      }
    </div>
  );
};
